module.exports = __webpack_public_path__ + "img/bike_red.9d9a2af4.svg";